import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'; // Link
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Tab,Nav} from 'react-bootstrap'; // Col 
import {format as stringFormat} from 'react-string-format';
import cheif from '../../../assets/images/cheif.svg'

import ModalWindow from '../../commons/helpers/modalWindow'; 
import Toast from '../../commons/helpers/toast';
import CustomMultiSelect from '../../commons/helpers/customMultiSelect';

import { ROUTE_REFRESH, LOGIN_AFFILIATE_GROUP, DELETE_SYMBOL, MASTER_RATE_CARD_ROWS, PAGENUMROWS_AFFILIATE, ROUTE_AFFILIATE_RATECARDS } from '../../../configs/staticConfigs';
import { MSG_CATEGORY_DATA_COPIED_SUCCESS,MSG_MASTER_CARD_COPIED_SUCCESS,MSG_RATE_CARD_UPDATE_SUCCESS, MSG_RATE_CARD_UPDATE_ERROR, MSG_RATE_MISMATCH, MSG_ERROR, MSG_DATA_FETCH_CHIEF_BONUS_ERROR, MSG_DATA_UPDATE_CHIEF_BONUS_SUCCESS, MSG_DATA_UPDATE_CHIEF_BONUS_ERROR, MSG_REQUIRED, MSG_CHIEF_CHARGE_RATE_ERROR, MSG_CONFIRM_DATA_CHANGE_RATE, MSG_MASTER_RATE_CARD_SAVE } from '../../../configs/msgConfigs'; 
import { LBL_TO_CATEGORY,LBL_FROM_CATEGORY,LBL_COPY_CATEGORY,LBL_EDIT,LBL_COPY_RATE_CARD,LBL_CLIENTS,LBL_APP_NAME, LBL_SETTINGS, LBL_SKILL, LBL_MASTER_RATE_CARD, LBL_PAY_RATE, LBL_CHARGE_RATE, LBL_HOURS, LBL_CREW_CHIEF, LBL_CHIEF_PAY_RATE, LBL_CHIEF_CHARGE_RATE, LBL_SAVE, LBL_BTN_ADD_STC, LBL_FOR, LBL_HRS_ABOVE, LBL_HOUR_SHORT, LBL_HOURS_SHORT, LBL_CONFIRM_DELETE_ROW, LBL_REMOVE_ROW, LBL_COPY_RATES_TO, LBL_CONFIRM_DELETE, LBL_CONFIRM_DATA_CHANGE, LBL_SEL_CATEGORY, LBL_FROM_CLIENT_CATEGORY, LBL_TO_CLIENT_CATEGORY, LBL_RATE_CARDS, LBL_BACK_TO_SETTINGS } from '../../../configs/labelConfigs';

import { rateCardListAction, rateCardUpdateAction, getRateCardChiefBonusAction,  updateRateCardChiefBonusAction, setRateCardNamePageSubTitle } from '../../../actions/settings/affiliates/aflt_masterratecardActions'; 
// CopyCategoryToCategory,CopyMasterCardToClient  

import { clearAction} from '../../../actions/commonActions';
import { COPY_CATEGORY_TO_CATEGORY_SUCCESS, COPY_MASTER_CARD_TO_CLIENT_SUCCESS,CLIENT_LIST_FOR_CATEGORIES_SUCCESS, PROFILE_CLIENT_CATEGORY_LIST_SUCCESS, RATE_CARD_LIST_SUCCESS, RATE_CARD_LIST_ERROR, RATE_CARD_UPDATE_SUCCESS, RATE_CARD_UPDATE_ERROR, RATECARD_CHEIF_BONUS_GET_SUCCESS, RATECARD_CHEIF_BONUS_GET_ERROR, RATECARD_CHEIF_BONUS_UPDATE_SUCCESS, RATECARD_CHEIF_BONUS_UPDATE_ERROR, RATE_CARDS_ALL_AFFILIATE_SUCCESS } from '../../../actions'; 
// import { ClientListForCategories,aflt_rateCardsAllAction} from '../../../actions/clientActions';
import { aflt_rateCardsAllAction, setDefaultRateCardId } from '../../../actions/settings/affiliates/aflt_rateCardsActions';

import {userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { decimalNumRegex, checkNumDot, checkNumDotZero} from '../../../utils/validation'; // formValid, 
import { changeColorBlue, changeColorNormal} from '../../../utils/displayFormats'; 
import {decimalTwo} from '../../../utils/commonUtilities'; 
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { URL_IMG } from '../../../configs/urlConfigs';

class MasterRateCardComponent extends Component {

    constructor(props){
        super(props)

        let profileId = '';

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup    = ''; 
        let grpProfileId = '';
        let profileCurrency = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            grpProfileId = userGroupData.profile_id;
            profileCurrency = userGroupData.profile_currency; 
        }

        if(userGroup===LOGIN_AFFILIATE_GROUP){
            profileId = grpProfileId;
        }else{
            profileId = this.props.match.params.id;
        }

        this.state = {
            editData:false,
            rateCardsListData: [],
            defaultRateCardId:'',     
            skillRatesAllData: [],  
            activeSkillRateData: { skill_id: 0, skill_name: '', rates_data: [] },    
            activeSkillId: 0,     
            deleteRowIndexNum: 0,
            isCopyCategoryActive:0,                      
            isCopyMasterCategory:0,                      
            formErrors:{
                fieldEmpty:'',
                crewChiefChargeRateLess: '',
                crewChiefPayRate: '',
                crewChiefChargeRate: '',
                rateCard: ''            
            },          
            profileId:profileId,
            profileCurrency:profileCurrency,
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false,
            activeSkillName:'',
            crewChiefPayRate: 0,
            crewChiefChargeRate: 0,
            isCrewChiefActive: 1,
            skillMultiListAll:[],
            skillMultiList:[],
            rateCopyToSkills:[],
            refSkillId: 0,
            skillName: '',
            clientList:[],
            clientIds:[],
            toMasterCategoryIds:[],
            clientIdError:true,
            rateCardIdFromPropsLoaded:false,
        }

        this.onHandleChange = this.onHandleChange.bind(this);
        this.saveFormData   = this.saveFormData.bind(this);
        this.changeSkill = this.changeSkill.bind(this); 
        this.addNewRow = this.addNewRow.bind(this); 
        this.removeRow = this.removeRow.bind(this); 
        this.checkFormData = this.checkFormData.bind(this); 

        this.modalConfirm = React.createRef(); 
        this.modalDelete = React.createRef();
    }

    enableEdit = ()=>{
        this.setState({editData:true});
    }
    onCopyRateDataChange = (selectedData) =>{
        let selSkills = []; 
        selectedData.forEach((item) => {
            selSkills.push(item.value);
        });
        this.setState({ rateCopyToSkills:selSkills });        
    }

    formatSkillData = (array) => {
        let skill = [];
        if(array.length>0){
            array.map(item => {
                let  skillObj = {};
                skillObj['value'] = item.id;
                skillObj['label'] = item.skill_name;
                skill.push(skillObj);
                return skill;
            });
        }
        return skill;
    }

    componentDidMount() {
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_RATE_CARDS;
        document.body.classList.add('body-affiliate'); 
        this.props.aflt_rateCardsAllAction({pageSize:PAGENUMROWS_AFFILIATE,page:0,column:'title'})   
    }

    onModalFormReset = () =>{  
        this.setState({deleteRowIndexNum:0,formClick:false}); 
        if(this.state.skillName.length > 1) {
            this.changeSkillActive('',this.state.refSkillId,this.state.skillName); 
        }
        this.props.aflt_rateCardsAllAction({pageSize:PAGENUMROWS_AFFILIATE,page:0,column:'title'})
    }

    changeSkill = (event,refSkillId,skillName) => {
        if(this.state.formClick===true) {
            this.modalConfirm.current.handleOpenModal(); 
            this.setState({formClick:false,refSkillId:refSkillId,skillName:skillName}); 
        } 
        else {
            this.changeSkillActive(event,refSkillId,skillName); 
            this.setState({formClick:false,refSkillId:0,skillName:''}); 
        }
    }

    changeSkillActive = (event,refSkillId,skillName) => {
        let allSkillRateObj = []; 
        let newActiveObj = {};
        if(skillName===LBL_CREW_CHIEF) {
            this.props.getRateCardChiefBonusAction({rateCardId:this.state.defaultRateCardId});
            this.setState({editData:false,isCopyMasterCategory:0,isCopyCategoryActive:0, isCrewChiefActive:1, activeSkillId:0, activeSkillRateData: newActiveObj,toastFlag:false,toastMessage:'',toastSuccess:true,activeSkillName:''}); 
        }
        // else if(skillName ==='copyRateCard'){
        //     this.setState({editData:false,isCopyMasterCategory:0,isCopyCategoryActive:1,isCrewChiefActive:0,activeSkillId:0,activeSkillRateData: newActiveObj,toastFlag:false,toastMessage:'',toastSuccess:true,activeSkillName:''})
        // }else if(skillName ==='copyCategory'){
        //     this.setState({editData:false,isCopyMasterCategory:1,isCopyCategoryActive:0,isCrewChiefActive:0,activeSkillId:0,activeSkillRateData: newActiveObj,toastFlag:false,toastMessage:'',toastSuccess:true,activeSkillName:''})
        // }
        else if(this.state.activeSkillId!==refSkillId) {
            this.state.skillRatesAllData.forEach((item,index) => {
                if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(this.state.activeSkillRateData); 
                else allSkillRateObj.push(item); 
                if(item.skill_id===refSkillId)  {
                    newActiveObj = item;
                }
            }); 

            // MODIFY THE MULTI SELECT SKILL DATA ALSO 
            let allSkills = this.state.skillMultiListAll;
            let multiSeldata = []; 
            multiSeldata = allSkills.filter(item => Number(item.value)!==Number(refSkillId)); 

            this.setState({editData:false,isCopyMasterCategory:0,isCopyCategoryActive:0,isCrewChiefActive:0,activeSkillId:refSkillId, activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj,toastFlag:false,toastMessage:'',toastSuccess:true,activeSkillName:skillName,skillMultiList:multiSeldata,rateCopyToSkills:[]});  
        }   
    }

    onHandleChange = (e, rateIndex,fieldName) =>{
        e.preventDefault();
        // this.setState({formClick:true}); // to track form update without any value change in component did update 
        
        const {value}  = e.target;
        let formErrors      = this.state.formErrors;
        let activeData      = this.state.activeSkillRateData; 
        let valStr = value.trim(); 
        let finalIndex = 0;

        if(fieldName==='rateCard') {  
            if(Number(value) > 0) {
                formErrors.rateCard = ''; 
                this.setState({formClick:false, defaultRateCardId:value,formErrors}, () => {
                    this.props.getRateCardChiefBonusAction({rateCardId:this.state.defaultRateCardId});
                    this.props.rateCardListAction(this.state.defaultRateCardId);
                });
                const sel = e.target;
                this.props.setRateCardNamePageSubTitle(sel.options[sel.selectedIndex].text); 
            }
            else {
                formErrors.rateCard = MSG_REQUIRED; 
                this.setState({formClick:true, defaultRateCardId:'0', crewChiefPayRate:0, crewChiefChargeRate:0, formErrors}); 
                this.props.setRateCardNamePageSubTitle(''); 
            }
        }
        if(fieldName==='crewChiefPayRate') {  
            formErrors.crewChiefChargeRateLess = ''; 
            formErrors.crewChiefPayRate = valStr.length <=0 || decimalNumRegex.test(valStr) === false
            ? MSG_REQUIRED : ""; 
            if(valStr && valStr !== '' && !checkNumDotZero(valStr)) { valStr = ''; }
            else if(valStr && valStr !== '') {
                let t = valStr; 
                valStr = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
            }
            this.setState({formClick:true, crewChiefPayRate:valStr, formErrors});  
        }     

        if(fieldName==='crewChiefChargeRate') { 
            formErrors.crewChiefChargeRateLess = ''; 
            formErrors.crewChiefChargeRate = valStr.length <=0 || decimalNumRegex.test(valStr) === false
            ? MSG_REQUIRED : "";
            if(valStr && valStr !== '' && !checkNumDotZero(valStr)) { valStr = ''; }
            else if(valStr && valStr !== '') {
                let t = valStr; 
                valStr = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
            }
            this.setState({formClick:true, crewChiefChargeRate:valStr, formErrors});  
        }

        let tmpRate = 0; 
        // activeSkillRateData rates_data  hours pay_rate charge_rate is_final 
        if(fieldName==='pay_rate') {
            formErrors.fieldEmpty = ''; 
            if(!checkNumDotZero(valStr))  {
                //formErrors.fieldEmpty = MSG_NOT_VALID_ERROR; 
                valStr = ''; 
            }
            valStr = decimalTwo(valStr); 
            activeData.rates_data[rateIndex].pay_rate = valStr; 
            tmpRate = parseFloat(valStr); 
            if(tmpRate && Number(rateIndex)===(MASTER_RATE_CARD_ROWS-1)) {
                finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
                activeData.rates_data[finalIndex].pay_rate = parseFloat(tmpRate/MASTER_RATE_CARD_ROWS).toFixed(2); 
            }
            else if(Number(rateIndex)===0) {
                let newRateData = []; 
                activeData.rates_data.forEach(rateItem => {
                    if(rateItem.hours > 1 && !rateItem.is_final) {
                        rateItem.pay_rate = parseFloat(rateItem.hours*valStr).toFixed(2); 
                    }
                    else if(rateItem.is_final) {
                        rateItem.pay_rate = parseFloat(valStr).toFixed(2); 
                    }
                    newRateData.push(rateItem); 
                })
                activeData.rates_data = newRateData; 
            }
            this.setState({formClick:true,activeSkillRateData:activeData, formErrors:formErrors});  
        } 
        else if(fieldName==='charge_rate') { 
            formErrors.fieldEmpty = ''; 
            if(!checkNumDotZero(valStr))  {
                //formErrors.fieldEmpty = MSG_NOT_VALID_ERROR; 
                valStr = ''; 
            }
            valStr = decimalTwo(valStr); 
            activeData.rates_data[rateIndex].charge_rate = valStr; 
            tmpRate = parseFloat(valStr); 
            if(tmpRate && Number(rateIndex)===(MASTER_RATE_CARD_ROWS-1)) {
                finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
                activeData.rates_data[finalIndex].charge_rate = parseFloat(tmpRate/MASTER_RATE_CARD_ROWS).toFixed(2); 
            }
            else if(Number(rateIndex)===0) {
                // finalIndex = activeData.rates_data.findIndex(obj => obj.is_final === true);
                // activeData.rates_data[finalIndex].charge_rate = valStr; 
                let newRateData = []; 
                activeData.rates_data.forEach(rateItem => {
                    if(rateItem.hours > 1 && !rateItem.is_final) {
                        rateItem.charge_rate = parseFloat(rateItem.hours*valStr).toFixed(2); 
                    }
                    else if(rateItem.is_final) {
                        rateItem.charge_rate = parseFloat(valStr).toFixed(2); 
                    }
                    newRateData.push(rateItem); 
                })
                activeData.rates_data = newRateData; 
            }
            this.setState({formClick:true,activeSkillRateData:activeData, formErrors:formErrors});  
        }
    } 

    addNewRow = () => {
        let newRateObj = [];
        let newItem = {};
        this.state.activeSkillRateData.rates_data.forEach((item,index) => {
            if(item.is_final) {
                newItem = { hours: item.hours, pay_rate: parseFloat(0.00).toFixed(2), charge_rate: parseFloat(0.00).toFixed(2), is_final: false};
                newRateObj.push(newItem); 
                newItem = { hours: (item.hours+1), pay_rate: parseFloat(item.pay_rate).toFixed(2), charge_rate: parseFloat(item.charge_rate).toFixed(2), is_final: item.is_final};
                newRateObj.push(newItem); 
            }
            else {
                newRateObj.push(item); 
            }
        }); 
        // { skill_id: 0, skill_name: '', rates_data: [], is_final: false }
        let newActiveObj = this.state.activeSkillRateData; 
        newActiveObj.rates_data = newRateObj; 
        
        let allSkillRateObj = []; 
        this.state.skillRatesAllData.forEach((item,index) => {
            if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(newActiveObj); 
            else allSkillRateObj.push(item); 
        }); 

        this.setState({formClick:true,activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj}); 
    }

    removeRow = (rateIndex) => {
        let newRateObj = [];
        let newItem = {};
        let rowRemoved = 0; 
        this.state.activeSkillRateData.rates_data.forEach((item,index) => {
            if(index<rateIndex) newRateObj.push(item); 
            else {
                if(rowRemoved===0) {
                    rowRemoved++; 
                }
                else {
                    newItem = { hours: (item.hours-1), pay_rate: item.pay_rate, charge_rate: item.charge_rate, is_final: item.is_final};
                    newRateObj.push(newItem); 
                }
            }
        }); 
        // { skill_id: 0, skill_name: '', rates_data: [], is_final: false}
        let newActiveObj = this.state.activeSkillRateData; 
        newActiveObj.rates_data = newRateObj; 
        
        let allSkillRateObj = []; 
        this.state.skillRatesAllData.forEach((item,index) => {
            if(item.skill_id===this.state.activeSkillId) allSkillRateObj.push(newActiveObj); 
            else allSkillRateObj.push(item); 
        }); 

        let frmErr = this.state.formErrors; 
        frmErr.fieldEmpty = ''; 
        this.setState({formErrors: frmErr, formClick:true, activeSkillRateData: newActiveObj, skillRatesAllData:allSkillRateObj}); 
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:true});
    } 

    
    deleteBtnClick = (indexNum) =>{
        let pRate = this.state.activeSkillRateData.rates_data[indexNum].pay_rate; 
        let cRate = this.state.activeSkillRateData.rates_data[indexNum].charge_rate; 
        if( ((parseFloat(pRate) <= 0) || (pRate==='')) && (parseFloat(cRate) <= 0 || (cRate===''))) {
            this.setState({deleteRowIndexNum: indexNum}, () => this.removeRow(this.state.deleteRowIndexNum)); 
        }
        else {
            this.setState({deleteRowIndexNum: indexNum}, () => this.modalDelete.current.handleOpenModal());
        }
    }

    onDeleteAction = () =>{
        if(this.state.deleteRowIndexNum > 0) this.removeRow(this.state.deleteRowIndexNum);
        this.modalDelete.current.handleModelClose();             
    }

    checkFormData() {
        let foundError = 0; 
        let errMsg = this.state.formErrors; 
        this.state.activeSkillRateData.rates_data.map((item,index) => {
            if(parseFloat(item.pay_rate)===0 || parseFloat(item.charge_rate)===0) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(item.pay_rate==='' || item.charge_rate==='' || item.pay_rate===0 || item.charge_rate===0) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(!checkNumDot(item.pay_rate) || item.pay_rate===0) {  // checkNumDot,
                foundError = 1; 
                // errMsg.fieldEmpty = MSG_PAYRATE_REQUIRED;
                // this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(!checkNumDot(item.charge_rate) || item.charge_rate===0) {  
                foundError = 1; 
                //errMsg.fieldEmpty = MSG_CHARGERATE_REQUIRED;
                //this.setState({formErrors:errMsg});  
                return false; 
            } 
            else if(parseFloat(item.pay_rate) > parseFloat(item.charge_rate)) {   
                foundError = 1; 
                errMsg.fieldEmpty = MSG_RATE_MISMATCH;
                this.setState({formErrors:errMsg});  
                return false; 
            } 
            return(console.log('.')); 
        }); 
        if(foundError===0) {
            return true; 
        }
    }
    
    saveData = () => {
        if(this.state.isCrewChiefActive > 0) {
            this.saveChiefBonusData('');
        }
        else {
            this.saveFormData('');
        }
        this.modalConfirm.current.handleModelClose();  
    } 

    saveFormData = (e)=>{
        if(e) e.preventDefault(); 
        if(this.checkFormData()) {
            let saveDataObj = {
                skill_id : this.state.activeSkillRateData.skill_id,
                skill_name : this.state.activeSkillRateData.skill_name,
                rate_card_id:this.state.defaultRateCardId,
                other_skills: this.state.rateCopyToSkills, 
                rates_data : this.state.activeSkillRateData.rates_data
            };
            this.props.rateCardUpdateAction(saveDataObj);  
            this.setState({formClick:false});
        }
    }

    saveChiefBonusData = (e)=>{ 
        if(e) e.preventDefault(); 
        if(this.state.defaultRateCardId=='' || Number(this.state.defaultRateCardId) <= 0) {
            let formErrors = this.state.formErrors;
            formErrors.rateCard  = MSG_REQUIRED; 
            this.setState({formErrors}); 
        }
        else if(parseFloat(this.state.crewChiefPayRate) > parseFloat(this.state.crewChiefChargeRate)) {
            let formErrors = this.state.formErrors;
            let userGroupData = userGroupUrlCheck(window.location);
            let msg_toast = ''; 
            if(userGroupData!==undefined){
                msg_toast = stringFormat(MSG_CHIEF_CHARGE_RATE_ERROR,userGroupData.supervisor_name,userGroupData.supervisor_name);
            }   
            formErrors.crewChiefChargeRateLess  = msg_toast;   
            this.setState({formErrors}); 
        }
        else {
            // this.state.profileId 
            let saveDataObj = {
                rateCardId: this.state.defaultRateCardId,
                crew_chief_bonus : this.state.crewChiefChargeRate,
                crew_chief_pay_bonus : this.state.crewChiefPayRate
            }; 
            this.props.updateRateCardChiefBonusAction(saveDataObj);  
            this.setState({formClick:false});
        }
    }

    onRateCardChange = (e) =>{
        const value = e.target.value;
        this.setState({defaultRateCardId:value},() =>{
            this.props.rateCardListAction(this.state.defaultRateCardId);
        })  
        const sel = e.target;
        this.props.setRateCardNamePageSubTitle(sel.options[sel.selectedIndex].text);
    }
    onClientFromCategoryChange = (e) =>{
        const value = e.target.value;
        this.setState({activeFromCategoryId:value})
    }
    onCategoryFromCategoryChange = (e) =>{
        const value = e.target.value;
        this.setState({activeFromMasterCategoryId:value})
    }

    onCategoryTOCategoryChange = (selectedData) =>{
        let selCategories = []; 
        selectedData.forEach((item) => {
            selCategories.push(item.value);
        });
        this.setState({ toMasterCategoryIds:selCategories}); 
        
    }

    // onClientTOCategoryChange = (selectedData) =>{
    //     let selCategories = []; 
    //     selectedData.forEach((item) => {
    //         selCategories.push(item.value);
    //     });
    //     this.setState({ toCategoryIds:selCategories,clientIdError:this.state.clientIds.length?true:false}, () => {
    //         this.props.ClientListForCategories({selectedCategory:selCategories});
    //     }); 
        
    // }
    // copyCategoryData = () =>{
    //     if(this.state.clientIds.length === 0){
    //         this.setState({clientIdError:true});
    //     }else{
    //         this.props.CopyMasterCardToClient({fromClientCategoryId:this.state.activeFromCategoryId,clientIds:this.state.clientIds});
    //     }
    // }
    // copyMasterCategoryData = () =>{
    //     if(this.state.toMasterCategoryIds.length === 0){
    //         return
    //     }
    //     this.props.CopyCategoryToCategory({fromClientCategoryId:this.state.activeFromMasterCategoryId,toCategoryIds:this.state.toMasterCategoryIds});

    // }

    onClientListChange = (selectedData) =>{
        let selClients = []; 
        selectedData.forEach((item) => {
            selClients.push(item.value);
        });
        this.setState({ clientIds:selClients,clientIdError:selClients.length?true:false});
    }

    componentDidUpdate(prevProps) {       
        const { status, activity, rateCardChiefBonus, errorData, clientProfActivity, rateCardActivity, rateCardsAll, loadDefaultRateCardId } = this.props;

        if(rateCardActivity && rateCardActivity.length && rateCardActivity != prevProps.rateCardActivity) {
            let rcArrTemp = rateCardActivity.split('~~'); 
            let rcActString = rcArrTemp[0]; 
            if(rcActString===RATE_CARDS_ALL_AFFILIATE_SUCCESS){ 
                if(!this.state.rateCardIdFromPropsLoaded && loadDefaultRateCardId > 0) {
                    this.setState({rateCardsListData:rateCardsAll,
                        defaultRateCardId:loadDefaultRateCardId,rateCardIdFromPropsLoaded:true},() =>{
                        this.props.getRateCardChiefBonusAction({rateCardId:this.state.defaultRateCardId});
                        this.props.rateCardListAction(this.state.defaultRateCardId);
                        this.props.setDefaultRateCardId(0); 
                    });
                    let arrTmpRC = rateCardsAll.filter((rcITem) => rcITem.id===loadDefaultRateCardId); 
                    if(arrTmpRC && arrTmpRC.length > 0) {
                        this.props.setRateCardNamePageSubTitle(arrTmpRC[0].title); 
                    }
                }
                else {
                    const defaultItem = rateCardsAll[0]; 
                    this.setState({rateCardsListData:rateCardsAll,
                        defaultRateCardId:defaultItem.id},() =>{
                        this.props.getRateCardChiefBonusAction({rateCardId:this.state.defaultRateCardId});
                        this.props.rateCardListAction(this.state.defaultRateCardId);
                    });
                    this.props.setRateCardNamePageSubTitle(defaultItem.title); 
                }
                
                // COPY FROM TO - OPTION IS COMMENTED NOW - 17Feb2022
                // if(rateCardsAll.length > 0){
                //     let clientCategoryListObj = []
                //     rateCardsAll.forEach((cObj) => {
                //             clientCategoryListObj.push({ value:cObj.id, label:cObj.name });
                //     });
                //     this.setState({toClientCategorydata:clientCategoryListObj})
                // }
            }
        }

        if (activity && (status !== prevProps.status || activity!==prevProps.activity)) {
            if(status!==401) {   
                var arrResp = activity.split('~~'); 
                var actString = arrResp[0]; 
                if(actString===RATECARD_CHEIF_BONUS_GET_SUCCESS){  
                    if(status===200) {
                        // {id: 158, crew_chief_bonus: "12.00", crew_chief_pay_bonus: "8.00"}
                        let crewChiefPayRate = 0; 
                        let crewChiefChargeRate = 0; 
                        if(rateCardChiefBonus) {
                            if(rateCardChiefBonus.hasOwnProperty('crew_chief_bonus')) crewChiefChargeRate = rateCardChiefBonus.crew_chief_bonus; 
                            if(rateCardChiefBonus.hasOwnProperty('crew_chief_pay_bonus')) crewChiefPayRate = rateCardChiefBonus.crew_chief_pay_bonus; 
                            this.setState({isCrewChiefActive:1,crewChiefPayRate,crewChiefChargeRate}); 
                        }
                    }
                    else {
                        console.log(errorData);
                        let userGroupData = userGroupUrlCheck(this.props.location);
                        let msg_toast = '';  
                        if(userGroupData!==undefined){
                            msg_toast = stringFormat(MSG_DATA_FETCH_CHIEF_BONUS_ERROR,userGroupData.supervisor_name); 
                        } 
                        this.setState({toastFlag:true, toastSuccess:false, toastMessage:msg_toast});
                        setTimeout(()=> { this.onCloseToast(); }, 5000);
                    }
                } 
                else if(actString===RATECARD_CHEIF_BONUS_GET_ERROR) {
                    console.log(errorData);
                    let userGroupData = userGroupUrlCheck(this.props.location);
                    let msg_toast = '';  
                    if(userGroupData!==undefined){
                        msg_toast = stringFormat(MSG_DATA_FETCH_CHIEF_BONUS_ERROR,userGroupData.supervisor_name); 
                    } 
                    this.setState({toastFlag:true, toastSuccess:false, toastMessage:msg_toast});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }

                if(actString===RATECARD_CHEIF_BONUS_UPDATE_SUCCESS){ 
                    if(status===200) {
                        let userGroupData = userGroupUrlCheck(this.props.location);
                        let msg_toast = '';  
                        if(userGroupData!==undefined){
                            msg_toast = stringFormat(MSG_DATA_UPDATE_CHIEF_BONUS_SUCCESS,userGroupData.supervisor_name); 
                        }
                        this.setState({toastFlag:true, toastSuccess:true, toastMessage:msg_toast});
                        setTimeout(()=> { this.onCloseToast(); }, 4000);
                        this.setState({editData:false});
                    }
                    else {
                        let userGroupData = userGroupUrlCheck(this.props.location);
                        let msg_toast = '';  
                        if(userGroupData!==undefined){
                            msg_toast = stringFormat(MSG_DATA_UPDATE_CHIEF_BONUS_ERROR,userGroupData.supervisor_name); 
                        }
                        this.setState({toastFlag:true, toastSuccess:false, toastMessage:msg_toast});
                        setTimeout(()=> { this.onCloseToast(); }, 5000);
                    }
                }
                else if(actString===RATECARD_CHEIF_BONUS_UPDATE_ERROR) {
                    let userGroupData = userGroupUrlCheck(this.props.location);
                    let msg_toast = '';  
                    if(userGroupData!==undefined){
                        msg_toast = stringFormat(MSG_DATA_UPDATE_CHIEF_BONUS_ERROR,userGroupData.supervisor_name); 
                    }
                    this.setState({toastFlag:true, toastSuccess:false, toastMessage:msg_toast});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }

                // RATE CPYING COMMENTED ON 17FEB2022
                // if(actString===COPY_MASTER_CARD_TO_CLIENT_SUCCESS){
                //     this.setState({toastFlag:true, toastSuccess:true, toastMessage:MSG_MASTER_CARD_COPIED_SUCCESS});
                //     setTimeout(()=> { this.onCloseToast(); }, 5000);

                // }
                // if(actString===COPY_CATEGORY_TO_CATEGORY_SUCCESS){
                //     this.setState({toastFlag:true, toastSuccess:true, toastMessage:MSG_CATEGORY_DATA_COPIED_SUCCESS});
                //     setTimeout(()=> { this.onCloseToast(); }, 5000);

                // }
                

                if(actString===RATE_CARD_LIST_SUCCESS){ 
                    if(this.props.hasOwnProperty('skillRatesAllData')) {
                        if(this.props.skillRatesAllData.length===0) {
                            this.setState({skillRatesAllData: []}); 
                        }
                        else {
                            //let activeSkillName = this.props.skillRatesAllData[0].skill_name;
                            let tmpObj = {};
                            let rateObj = {};
                            let cnt = 0;
                            let skillMultiObj = []; 
                            let allSkillsObj = []; 
                            let newRateObj = [];
                            this.props.skillRatesAllData.forEach((rObj) => { 
                                cnt++; 
                                newRateObj = [];
                                if(!Array.isArray(rObj.rates_data)) rObj.rates_data = []; 
                                if(rObj.rates_data && rObj.rates_data.length===0) {
                                    let i = 0;
                                    for(i=0; i<MASTER_RATE_CARD_ROWS; i++) {
                                        newRateObj.push({ hours: (i+1), pay_rate: 0.00, charge_rate: 0.00, is_final: false}); 
                                    }
                                    newRateObj.push({ hours: (i+1), pay_rate: 0.00, charge_rate: 0.00, is_final: true}); 
                                }
                                else if(rObj.rates_data) { 
                                    rateObj =  rObj.rates_data; 
                                    newRateObj = [];
                                    let hourCnt = 0;
                                    let firstPayRate=0, firstChargeRate=0;  
                                    let lastPayRate=0, lastChargeRate=0; 
                                    rObj.rates_data.forEach(tmpItem => {
                                        if(!tmpItem.is_final) hourCnt = parseInt(tmpItem.hours,10); 
                                        if(hourCnt===1) {
                                            firstPayRate = parseFloat(tmpItem.pay_rate).toFixed(2); 
                                            firstChargeRate = parseFloat(tmpItem.charge_rate).toFixed(2);   
                                        }
                                        if((Number(tmpItem.hours) <=MASTER_RATE_CARD_ROWS && !tmpItem.is_final) || (Number(tmpItem.hours) > MASTER_RATE_CARD_ROWS && tmpItem.is_final)) {
                                            tmpItem.pay_rate = parseFloat(tmpItem.pay_rate).toFixed(2); 
                                            tmpItem.charge_rate = parseFloat(tmpItem.charge_rate).toFixed(2); 
                                            newRateObj.push(tmpItem); 
                                        }
                                    });

                                    // IF ROW < MASTER_RATE_CARD_ROWS, ADD THOSE ROWS TOO 
                                    if(hourCnt < MASTER_RATE_CARD_ROWS) {
                                        let i = 0;
                                        let lastPayRate=0, lastChargeRate=0; 
                                        for(i=(hourCnt+1); i<=MASTER_RATE_CARD_ROWS; i++) {
                                            lastPayRate     = parseFloat(firstPayRate*i).toFixed(2);
                                            lastChargeRate  = parseFloat(firstChargeRate*i).toFixed(2);
                                            newRateObj.push({ hours: i, pay_rate: lastPayRate, charge_rate: lastChargeRate, is_final: false}); 
                                        }
                                        // ADD THE FINAL ROW ALSO 
                                        newRateObj.push({ hours: (MASTER_RATE_CARD_ROWS+1), pay_rate: parseFloat(lastPayRate/MASTER_RATE_CARD_ROWS).toFixed(2), charge_rate: parseFloat(lastChargeRate/MASTER_RATE_CARD_ROWS).toFixed(2), is_final: true}); 
                                    }
                                }                         

                                tmpObj = {
                                    skill_id: rObj.skill_id,
                                    skill_name: rObj.skill_name, 
                                    skill_icon: rObj.skill_icon, 
                                    rates_data: newRateObj,
                                    is_final: rObj.is_final
                                };

                                skillMultiObj.push({ value:rObj.skill_id, label:rObj.skill_name});

                                allSkillsObj.push(tmpObj);
                                //return(console.log('.')); 
                                
                            });

                            let skillId = this.state.activeSkillId; 
                            let skillName = this.state.activeSkillName; 

                            this.setState({activeSkillId:0, activeSkillRateData: {}, skillRatesAllData: allSkillsObj,activeSkillName:'',skillMultiList:skillMultiObj,skillMultiListAll:skillMultiObj}, () => {
                                if(skillId > 0) {
                                    this.changeSkill('',skillId,skillName); 
                                }
                            }); // firstSkillId
                        }
                    } 
                    else { 
                        this.setState({skillRatesAllData: []}); 
                    }
                } 
                else if(actString===RATE_CARD_LIST_ERROR) { 
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ERROR});
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }
                else if(actString===RATE_CARD_UPDATE_SUCCESS){
                    this.setState({toastSuccess:true, toastFlag:true,toastMessage:MSG_RATE_CARD_UPDATE_SUCCESS});
                    // this.setToasterState(true,MSG_APPAYRATE_ADD_SUCCESS,true);
                    // IF COPY RATE TO OTHER SKILLS SELECTED, THEN RELOAD THE RATES FROM SERVER  
                    let rateCopyToSkills = this.state.rateCopyToSkills; 
                    if(Array.isArray(rateCopyToSkills) && rateCopyToSkills.length > 0) { 
                        this.props.rateCardListAction(this.state.defaultRateCardId); 
                    }
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                    this.setState({editData:false});
                }
                else if(actString===RATE_CARD_UPDATE_ERROR) {
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_RATE_CARD_UPDATE_ERROR}); 
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 3000);
                }  

            }
        }else if (activity !== prevProps.activity) {
            
        }

    }
    

    render(){
      
        const { status } = this.props;
        let { profileCurrency,toastMessage, toastFlag, toastSuccess, activeSkillRateData,activeSkillName,skillMultiList } = this.state;        


        if(!Array.isArray(activeSkillRateData.rates_data)) activeSkillRateData.rates_data = [];      

        if(status===401 || status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }
        let userGroupData = userGroupUrlCheck(this.props.location);
        let lblCrewChief = '';
        let lblChiefPayRate = ''; 
        let lblChiefChargeRate = '';  
        if(userGroupData!==undefined){
            lblCrewChief = userGroupData.supervisor_name;
            lblChiefPayRate = stringFormat(LBL_CHIEF_PAY_RATE,userGroupData.supervisor_name); 
            lblChiefChargeRate = stringFormat(LBL_CHIEF_CHARGE_RATE,userGroupData.supervisor_name); 
        }
        let txtClass = 'input-num-80';
        let txtErrorClass = 'input-num-80'+' input-error';
        if(!this.state.editData){
            txtErrorClass = txtErrorClass+' btn-edit-disable';
            txtClass = txtClass+' btn-edit-disable';
        }

        return(
            <React.Fragment>

                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                
                <Tab.Container id="rateCard-tab" defaultActiveKey="rateCard-chief-rate-tab">
                <div className='w-100 p-3'><Link to={ROUTE_AFFILIATE_RATECARDS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                
                    <div className="col-md-5 col-lg-4 col-xl-3 col-12">
                        <div className="box">
                            <div className="tab-head">
                            <div className="text-bold normalText leftPanelHeading ">{LBL_SKILL}</div>
                            </div>
                        </div>
                        <Nav variant="pills" className="rate-card nav flex-column nav-pills box">
                            { (this.state.isCrewChiefActive > 0) && <Nav.Link eventKey="rateCard-chief-rate-tab" >
                                <span className='spanPointer blueText text-bold'><img className='cheifimg-icon' src={cheif}/> {lblCrewChief} </span> </Nav.Link> }
                            { (this.state.isCrewChiefActive===0) && <Nav.Link eventKey="rateCard-chief-rate-tab" onClick={(e) => this.changeSkill(e, 0, LBL_CREW_CHIEF)} >
                                <span className='spanPointer text-bold normalText' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal} > {lblCrewChief} </span> </Nav.Link>}
                            
                            {this.state.hasOwnProperty('skillRatesAllData') && this.state.skillRatesAllData.map((item,index) => { 
                                if(this.state.activeSkillId===item.skill_id) {
                                    return(
                                    <Nav.Link eventKey="rateCard-details-tab" key={"navKey_"+index} >
                                        { (this.state.activeSkillId===item.skill_id) && 
                                        <span className='spanPointer blueText ' ><i className={'fas ' + item.skill_icon}></i> {item.skill_name} </span> 
                                        }
                                    </Nav.Link>
                                    ) 
                                }
                                else {
                                    return(
                                        <Nav.Link eventKey="rateCard-details-tab" key={"navKey_"+index} onClick={(e) => this.changeSkill(e, item.skill_id,item.skill_name)} >
                                            <span className='spanPointer normalText' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal} > <i className={'fas ' + item.skill_icon}></i> {item.skill_name} </span>
                                           
                                        </Nav.Link>
                                    )
                                }
                            } ) }

                        </Nav>

                        {/* // COPY FROM TO - OPTION IS COMMENTED NOW - 17Feb2022 */}
                        {/* <Nav variant="pills" className="rate-card nav flex-column nav-pills box marginTop15">
                            <Nav.Link eventKey="copy-category-tab" onClick={(e) => this.changeSkill(e, 0, 'copyCategory')} >
                                { (this.state.isCopyMasterCategory > 0) && 
                                <span className='spanPointer blueText text-bold ' > {LBL_COPY_CATEGORY} </span> }
                                { (this.state.isCopyMasterCategory===0) && 
                                <span className='spanPointer text-bold normalText' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal}  onClick={(e) => this.changeSkill(e, 0, 'copyCategory')}> {LBL_COPY_CATEGORY} </span> }
                            </Nav.Link>
                        </Nav> */}
                        {/* // COPY FROM TO - OPTION IS COMMENTED NOW - 17Feb2022 */}
                        {/* <Nav variant="pills" className="rate-card nav flex-column nav-pills box">
                            <Nav.Link eventKey="rateCard-copy-rate-tab" onClick={(e) => this.changeSkill(e, 0, 'copyRateCard')} >
                                { (this.state.isCopyCategoryActive > 0) && 
                                <span className='spanPointer blueText text-bold ' > {LBL_COPY_RATE_CARD} </span> }
                                { (this.state.isCopyCategoryActive===0) && 
                                <span className='spanPointer text-bold normalText' onMouseOver={changeColorBlue} onMouseOut={changeColorNormal}  onClick={(e) => this.changeSkill(e, 0, 'copyRateCard')}> {LBL_COPY_RATE_CARD} </span> }
                            </Nav.Link>
                        </Nav> */}
                    </div>
                    

                    <div className="col-md-4 col-lg-7 col-xl-8 col-10 pl-0">
                        <Tab.Content>
                            {/* // COPY FROM TO - OPTION IS COMMENTED NOW - 17Feb2022 */}
                             {/* <Tab.Pane eventKey="copy-category-tab">
                                <div className="box">
                                    <div className="tab-head">
                                        <div className="float-left"><h6>{LBL_COPY_CATEGORY}</h6></div>
                                        <div className="float-right paddingRight23">&nbsp;</div>
                                        <div className="divFloatRight padding-left-12 paddingRight3"><button className="btn btn-primary  saveBtnMinWidth" onClick={this.copyMasterCategoryData} > {LBL_SAVE} </button></div>  
                                    </div>
                                    <div className="box-content">
                                        <div className="table-responsive height30rem">
                                            <table id="data-table" className='table col-12'  >
                                                <tbody>
                                                    <tr className="borderTopWhite">    
                                                        <td className="text-left borderTopWhite">
                                                            <span className="marginLeft15">{LBL_FROM_CATEGORY}</span>
                                                        </td>
                                                        <td className="text-left borderTopWhite">
                                                            <div className="form-group multisel_textbox width450 text-12">
                                                                <div className="form-group select-input width450 text-12">
                                                                    <div className="form-group select-input">
                                                                        <select onChange={this.onCategoryFromCategoryChange} name="fromCategory" className={''} value={this.state.activeFromMasterCategoryId} >
                                                                            {this.state.rateCardsListData.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}  
                                                                        </select>
                                                                    </div>
                                                                </div> 
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>    
                                                        <td className="text-left">
                                                            <span className="marginLeft15">{LBL_TO_CATEGORY}</span>
                                                        </td>
                                                        <td className="text-left">
                                                            <div className="form-group multisel_textbox width450 text-12">
                                                                <div className="form-group select-input width450 text-12">
                                                                    <CustomMultiSelect initialText={'Select Category'} data={this.state.toClientCategorydata}  onChange={selected =>this.onCategoryTOCategoryChange(selected)} isTextBox={false} classValue={this.state.toMasterCategoryIds && this.state.toMasterCategoryIds.length ? "text-14-color width450" : "text-14-color width450 input-error"}btnTextClass="text-14-color" needSelectAll={true} />
                                                                </div> 
                                                            </div>
                                                        </td>
                                                    </tr>     
                                                </tbody>
                                            </table>
                                            
                                        </div>
                                        
                                    </div>
                                </div>
                             </Tab.Pane> */}

                             {/* // COPY FROM TO - OPTION IS COMMENTED NOW - 17Feb2022 */}
                             {/* <Tab.Pane eventKey="rateCard-copy-rate-tab">
                                <div className="box">
                                    <div className="tab-head">
                                        <div className="float-left"><h6>{LBL_COPY_RATE_CARD}</h6></div>
                                        <div className="float-right paddingRight23">&nbsp;</div>
                                        <div className="divFloatRight padding-left-12 paddingRight3"><button className="btn btn-primary  saveBtnMinWidth" onClick={this.copyCategoryData} > {LBL_SAVE} </button></div>  
                                    </div>
                                    <div className="box-content">
                                        <div className="table-responsive height30rem">
                                            <table id="data-table" className='table col-12'  >
                                                <tbody>
                                                    <tr className="borderTopWhite">    
                                                        <td className="text-left borderTopWhite">
                                                            <span className="marginLeft15">{LBL_FROM_CLIENT_CATEGORY}</span>
                                                        </td>
                                                        <td className="text-left borderTopWhite">
                                                            <div className="form-group multisel_textbox width450 text-12">
                                                                <div className="form-group select-input width450 text-12">
                                                                    <div className="form-group select-input">
                                                                        <select onChange={this.onClientFromCategoryChange} name="fromCategory" className={''} value={this.state.activeFromCategoryId} >
                                                                            {this.state.rateCardsListData.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}  
                                                                        </select>
                                                                    </div>
                                                                </div> 
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>    
                                                        <td className="text-left">
                                                            <span className="marginLeft15">{LBL_TO_CLIENT_CATEGORY}</span>
                                                        </td>
                                                        <td className="text-left">
                                                            <div className="form-group multisel_textbox width450 text-12">
                                                                <div className="form-group select-input width450 text-12">
                                                                    <CustomMultiSelect initialText={'Select Client Category'} data={this.state.toClientCategorydata}  onChange={selected =>this.onClientTOCategoryChange(selected)} isTextBox={false} classValue={this.state.toCategoryIds && this.state.toCategoryIds.length ? "text-14-color width450" : "text-14-color width450 input-error"}btnTextClass="text-14-color" needSelectAll={true} />
                                                                </div> 
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-left"><span className="marginLeft15"> {LBL_CLIENTS}</span> </td>

                                                        <td className="text-left" colSpan="2"> 
                                                            <div className="form-group multisel_textbox width450 text-12">
                                                                <div className="form-group select-input width450 text-12">
                                                                    <CustomMultiSelect initialText={'Select Client'} data={this.state.clientList}  onChange={selected =>this.onClientListChange(selected)} isTextBox={false} classValue={this.state.clientIds && this.state.clientIds.length ? "text-14-color width450": "text-14-color width450 input-error"} btnTextClass="text-14-color" />
                                                                </div> 
                                                            </div>
                                                        </td>

                                                    </tr>   
                                                     
                                                </tbody>
                                            </table>
                                            
                                        </div>
                                        
                                    </div>
                                </div>
                             </Tab.Pane> */}

                            <Tab.Pane eventKey="rateCard-chief-rate-tab">
                                <div className="box">
                                    <div className="tab-head">
                                        <div className="float-left"><h6>{lblCrewChief}</h6></div>
                                        <div className="float-right paddingRight23">&nbsp;</div>
                                    </div>
                                    <div className="box-content">
                                        {/* <div className="row"></div> */}
                                        <div className="row col-md-6 form-group displayItemFlex padding-left-20 "> 
                                            <label className="padding6">{LBL_RATE_CARDS}</label>
                                            <div className="pay-level-input">
                                                <div className="form-group select-input">
                                                    <select name="rateCard" onChange={this.props.onHandleChange} className={this.state.formErrors.rateCard.length>0?'input-error':''} value={this.state.defaultRateCardId} onChange={(e) => this.onHandleChange(e,0,'rateCard')}  >
                                                    <option key="0" value="0">{LBL_SEL_CATEGORY}</option>
                                                    {Array.isArray(this.props.rateCardsAll) && this.props.rateCardsAll.map((item) => <option key={item.id} value={item.id}>{item.title}</option>)} 
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive">

                                            <table id="data-table" className='table col-12'  >
                                                <thead>
                                                    {/* <tr>
                                                        <td className="text-left" colSpan="2">
                                                        </td>
                                                        <td className="text-left">&nbsp;</td>
                                                        <td className="text-left">&nbsp;</td>
                                                    </tr> */}
                                                    <tr className="text-bold">
                                                        <th className="text-left">{lblChiefPayRate+' ('+profileCurrency+')'}</th>
                                                        <th className="text-left">{lblChiefChargeRate+' ('+profileCurrency+')'}</th>
                                                        <th className="text-left">&nbsp;</th>
                                                        <th className="text-left">&nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>    
                                                        <td className="text-left">
                                                            <div className="form-group text-input"><input type="text" name="crewChiefPayRate" className={this.state.formErrors.crewChiefPayRate.length >0 ? txtErrorClass : txtClass} onChange={(e) => this.onHandleChange(e,0,'crewChiefPayRate')} value={this.state.crewChiefPayRate} maxLength={8} disabled={this.state.editData?"":true}/></div>
                                                        </td>
                                                        <td className="text-left">
                                                            <div className="form-group text-input"><input type="text" name="crewChiefChargeRate" className={this.state.formErrors.crewChiefChargeRate.length >0 ? txtErrorClass : txtClass} onChange={(e) => this.onHandleChange(e,0,'crewChiefChargeRate')} value={this.state.crewChiefChargeRate} maxLength={8} disabled={this.state.editData?"":true}/></div>
                                                        </td>
                                                        <th className="text-left">&nbsp;</th>
                                                        <th className="text-left">&nbsp;</th>
                                                    </tr>   
                                                    <tr> 
                                                        <td colSpan="4"> 
                                                            <div className="divFloatRight">
                                                                {this.state.formErrors.crewChiefChargeRateLess.length >=0 && <div className="text-red"><small>{this.state.formErrors.crewChiefChargeRateLess}</small></div>}
                                                                {/* <div className="divFloatRight"><button className="btn btn-primary launch-modal saveBtnMinWidth" onClick={this.saveChiefBonusData} > {LBL_SAVE} </button></div> 
                                                                 */}
                                                                    <div className="divFloatRight padding-left-12 paddingRight3"><button className="btn btn-primary  saveBtnMinWidth" onClick={this.state.editData?this.saveChiefBonusData:this.enableEdit} > {this.state.editData?LBL_SAVE:LBL_EDIT} </button></div>  
                                                                    {/*<div className="divFloatLeft text-left text-bold width-75-percent padding-top-10">{MSG_MASTER_RATE_CARD_SAVE}</div>*/}
                                                                </div>
                                                                <div>
                                                            </div>   
                                                        </td>
                                                    </tr> 
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>              
                                </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="rateCard-details-tab">
                                <div className="box">
                                    <div className="tab-head">
                                        <div >
                                            <div className="row">
                                                <div className="col-md-4">
                                                </div>
                                                <div className="col-md-4 item-align-center">
                                                    <h6 className="padding6 floatNone">{activeSkillName}</h6>
                                                </div>
                                                <div className="col-md-4">
                                                </div>
                                            </div>
                                            <div className="row">
                                                
                                                <div className="col-md-6 form-group displayItemFlex"> 
                                                    <label className="padding6">{LBL_RATE_CARDS}</label>
                                                    <div className="pay-level-input">
                                                        <div className="form-group select-input">
                                                            <select name="rateCard" onChange={this.onRateCardChange}  className={''} value={this.state.defaultRateCardId} >
                                                                {this.state.rateCardsListData.map((item) => <option key={item.id} value={item.id}>{item.title}</option>)}  
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 form-group">
                                                    {/* <div className="float-right paddingRight23 hide"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addNewRow()} >{LBL_BTN_ADD_STC}</button></div> */}
                                                    { activeSkillRateData.rates_data && activeSkillRateData.rates_data.length > 0 && <div className="float-right paddingRight23"><button className="btn btn-primary launch-modal saveBtnMinWidth" onClick={this.state.editData?this.saveFormData:this.enableEdit} > {this.state.editData?LBL_SAVE:LBL_EDIT} </button></div>
                                                    }
                                                    
                                                    <div className="warningMasterCard">
                                                    {this.state.formErrors.fieldEmpty.length >0 && (
                                                        <div className="text-red to-right text-right"><small>{this.state.formErrors.fieldEmpty}</small></div>
                                                    )} 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                                    
                                    </div>
                                    <div className="box-content">
                                    <div className="table-responsive">
                                        {this.state.hasOwnProperty('activeSkillRateData') && 
                                        <table id="data-table" className='table width-100-percent'>
                                            <thead>
                                            <tr className="text-bold">
                                                <th className="text-center width-30-percent">{LBL_HOURS}</th>

                                                <th className="text-left width-35-percent">{LBL_PAY_RATE+' ('+profileCurrency+')'}</th>

                                                <th className="text-left width-35-percent">{LBL_CHARGE_RATE+' ('+profileCurrency+')'}</th>
                                            </tr>
                                            </thead> 
                                            <tbody>
                                            
                                            {activeSkillRateData.rates_data && activeSkillRateData.rates_data.map( (rateObj,rateIndex) => {  
                                            if(!rateObj.is_final) return( 
                                                <tr key={activeSkillRateData.skill_id+'_'+rateObj.hours}> 
                                                    <td className="text-center">{rateObj.hours} </td>
                                                    {/*<td className="text-left">&nbsp;</td> */}
                                                   

                                                    <td className="text-left"> 
                                                        <div className="form-group text-input">
                                                            <input className={(parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate) <= 0 || this.state.activeSkillRateData.rates_data[rateIndex].pay_rate.trim()==='') ? txtErrorClass : txtClass} name={"txt_payRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].pay_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'pay_rate')} maxLength = {10} disabled={this.state.editData?"":true} /> 
                                                            
                                                            {' '+LBL_FOR.toLowerCase()+' '+rateObj.hours} {Number(rateObj.hours)===1 ? ' '+LBL_HOUR_SHORT.toLowerCase() : ' '+LBL_HOURS_SHORT.toLowerCase()}
                                                        </div> 
                                                    </td>
                                                   {/* <td className="text-left">&nbsp;</td> */}

                                                    <td className="text-left"> <div className="form-group text-input"><input className={(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate <= 0  || this.state.activeSkillRateData.rates_data[rateIndex].charge_rate.trim()==='' || (parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate) < parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate))) ? txtErrorClass : txtClass} name={"txt_chargeRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].charge_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'charge_rate')} maxLength = {10} disabled={this.state.editData?"":true} /> 
                                                    
                                                    {' '+LBL_FOR.toLowerCase()+' '+rateObj.hours} {Number(rateObj.hours)===1 ? ' '+LBL_HOUR_SHORT.toLowerCase() : ' '+LBL_HOURS_SHORT.toLowerCase()}
                                                    </div>
                                                    </td>
                                                      
                                                </tr>
                                            ) 
                                            if(rateObj.is_final) return(
                                            
                                            <tr key={activeSkillRateData.skill_id+'_'+rateObj.hours}> 
                                                <td className="text-center verticalTop" >
                                                    <span className="hide22">{LBL_FOR} <span className="text-bold text-15">{this.state.activeSkillRateData.rates_data.length}</span> {LBL_HRS_ABOVE}</span></td> 

                                                <td className="text-left verticalTop">
                                                    <span className="hide22">
                                                    <div className="form-group text-input"><input className={parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate) <= 0 ? txtErrorClass : txtClass} name={"txt_payRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].pay_rate} onChange={(e) => this.onHandleChange(e,rateIndex,'pay_rate')} maxLength = {10} disabled={this.state.editData?"":true}/> /{LBL_HOUR_SHORT.toLowerCase()} </div></span>
                                                </td> 

                                                <td className="text-left verticalTop">
                                                    <span className="hide22">
                                                    <div className="form-group text-input"><input className={(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate <= 0 || (parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].charge_rate) < parseFloat(this.state.activeSkillRateData.rates_data[rateIndex].pay_rate))) ? txtErrorClass : txtClass}  name={"txt_chargeRate_"+activeSkillRateData.skill_id+'_'+rateObj.hours} value={this.state.activeSkillRateData.rates_data[rateIndex].charge_rate} onChange={(e) => this.onHandleChange(e, rateIndex,'charge_rate')} maxLength = {10} disabled={this.state.editData?"":true}/> /{LBL_HOUR_SHORT.toLowerCase()}</div> 
                                                    </span>
                                                </td> 

                                            </tr>
                                            ) 
                                            }
                                        
                                            )}

                                            {/* COPY RATES OPTIONS COMMENTED ON 17FEB2022 */}

                                            {activeSkillRateData.rates_data && activeSkillRateData.rates_data.length > 0 && <tr> 
                                                <td className="text-center"> {stringFormat(LBL_COPY_RATES_TO,"'"+activeSkillName+"'")} </td>

                                                <td className="text-left" colSpan="2"> 
                                                    <div className="text-optional form-group multisel_textbox width300 text-12">
                                                        <div className=" text-optional form-group select-input width300 text-12">
                                                            <CustomMultiSelect isDisable={this.state.editData?false:true} data={skillMultiList}  onChange={selected =>this.onCopyRateDataChange(selected)} isTextBox={false} classValue="text-14-color width300" btnTextClass="text-14-color"  marginTop0='marginTop0' />
                                                        </div> 
                                                    </div>
                                                </td>
                                            </tr>}

                                            {/* <td className="text-left">&nbsp; </td> */}

                                            {activeSkillRateData.rates_data && activeSkillRateData.rates_data.length > 0 && <tr>
                                                <td colSpan="3" className="text-right width-100-percent">
                                                    {this.state.formErrors.fieldEmpty.length >0 && (
                                                         <div className="text-red to-right text-right"><small>{this.state.formErrors.fieldEmpty}</small></div>
                                                     )} 
                                                    
                                                        <div>
                                                            <div className="divFloatRight padding-left-12 paddingRight3"><button className="btn btn-primary  saveBtnMinWidth" onClick={this.state.editData?this.saveFormData:this.enableEdit} > {this.state.editData?LBL_SAVE:LBL_EDIT} </button></div>  
                                                            {/*<div className="divFloatLeft text-left text-bold width-75-percent padding-top-10">{MSG_MASTER_RATE_CARD_SAVE}</div>*/}
                                                        </div>
                                                    
                                                </td>
                                            </tr>}
                                            
                                            </tbody>
                                        </table>
                                        }    
                                        </div>
                                    </div>    
                                </div>       
                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                   
                </Tab.Container> 
                
                <ModalWindow ref={this.modalConfirm}  header={LBL_CONFIRM_DATA_CHANGE} type="save" saveFormData={this.saveData} resetModalForm={this.onModalFormReset}> {MSG_CONFIRM_DATA_CHANGE_RATE} </ModalWindow> 

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}> {LBL_CONFIRM_DELETE_ROW} </ModalWindow>  

            </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
    console.log('state.afltRateCards.loadDefaultRateCardId: '+state.afltRateCards.loadDefaultRateCardId); 
    return {
        skillRatesAllData:state.masterRateCard.skillRateCardAllItems.data,
        status:state.masterRateCard.status,
        activity:state.masterRateCard.activity,
        rateCardChiefBonus:state.masterRateCard.rateCardChiefBonus, 
        errorData:state.masterRateCard.errorData,
        clientProfActivity:state.clients.clientProfActivity,
        clientListCategoryWise:state.clients.clientListCategoryWise,
        rateCardsAll:state.afltRateCards.rateCardsAll, 
        rateCardActivity:state.afltRateCards.activity,
        loadDefaultRateCardId: state.afltRateCards.loadDefaultRateCardId, 
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        rateCardListAction:rateCardListAction,
        rateCardUpdateAction:data=>rateCardUpdateAction(data), 
        getRateCardChiefBonusAction:getRateCardChiefBonusAction,
        updateRateCardChiefBonusAction:updateRateCardChiefBonusAction,
        setRateCardNamePageSubTitle:setRateCardNamePageSubTitle,
        aflt_rateCardsAllAction:aflt_rateCardsAllAction,
        setDefaultRateCardId,setDefaultRateCardId,
        // ClientListForCategories:ClientListForCategories,
        // CopyMasterCardToClient:CopyMasterCardToClient,
        // CopyCategoryToCategory:CopyCategoryToCategory,
        clearAction:clearAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(MasterRateCardComponent);
